import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IUserAddress } from 'src/modules/authentication/interfaces/user-address.interface';
import { HomecarePatient } from '../../interfaces/homecare-patient.interface';
import { NewPatientFormComponent } from '../new-patient-form/new-patient-form.component';
import { ShiftPatientComponent } from '../shift-patient/shift-patient.component';

@Component({
  selector: 'app-single-patient-shift-selection',
  templateUrl: './single-patient-shift-selection.component.html',
  styleUrls: ['./single-patient-shift-selection.component.scss'],
})
export class SinglePatientShiftSelectionComponent implements OnInit {

  @Input() entityId: string;
  @Input() availablePatients: HomecarePatient[] = [];
  @Input() currentView?: string;
  @Input() isPostalCodeRequired: boolean = false;
  @Input() formSubmitted: boolean = false;

  /**
   * Extra cssClass for the modal this component opens. The create-shift page
   * passes 'staffy-modal' to get the redesigned chrome; the screens that have
   * not been redesigned pass nothing and keep the existing look.
   */
  @Input() modalCssClass: string = '';

  /**
   * Extra cssClass for the dropdown popup, forwarded to app-shift-patient.
   * The create-shift page passes 'staffy-select'.
   */
  @Input() selectCssClass: string = '';


  @Output() onPatientChange: EventEmitter<HomecarePatient> = new EventEmitter();
  @ViewChild(ShiftPatientComponent) shiftPatientComponent!: ShiftPatientComponent;


  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
    console.log('currentView', this.currentView);
  }

  handlePatientChange(data){
    this.onPatientChange.emit(data);
  }


  async showNewPatientForm(){
    const patientModal = await this.modalController.create({
      component: NewPatientFormComponent,
      cssClass: ('patientsModal ' + this.modalCssClass).trim(),
      backdropDismiss: true,
      componentProps: {
        entityId: this.entityId,
        addPatientAddress: (newPatient: {id: string, address: IUserAddress}) => {
          this.availablePatients.push(newPatient);
        }
      }
    });

    patientModal.present();
  }

  resetShiftPatient() {
    this.shiftPatientComponent.reset();
  }

}
